import { render, staticRenderFns } from "./HomeMessage.vue?vue&type=template&id=388597aa&scoped=true&"
import script from "./HomeMessage.vue?vue&type=script&lang=js&"
export * from "./HomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./HomeMessage.vue?vue&type=style&index=0&id=388597aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388597aa",
  null
  
)

export default component.exports